/**
 * A skeleton loading state for the AssemblyTable component.
 * Provides a visual placeholder while assembly data is being loaded.
 */
import {
  Paper,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';

const DEFAULT_COLUMNS = 8; // Match the number of columns in AssemblyTable
const DEFAULT_ROWS = 10;

/**
 * Props for the AssemblyTableSkeleton component.
 */
interface Props {
  /**
   * Number of columns to display in the skeleton.
   * @default 8
   */
  columns?: number;

  /**
   * Number of rows to display in the skeleton.
   * @default 10
   */
  rows?: number;
}

/**
 * A skeleton loading state for the AssemblyTable component.
 * Matches the structure and layout of the actual table.
 */
export function AssemblyTableSkeleton({
  columns = DEFAULT_COLUMNS,
  rows = DEFAULT_ROWS,
}: Props) {
  return (
    <TableContainer component={Paper} variant="outlined">
      <Table>
        <TableHead>
          <TableRow>
            {Array.from({ length: columns }).map((_, index) => (
              <TableCell key={index}>
                <Skeleton variant="text" width="80%" />
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {Array.from({ length: rows }).map((_, rowIndex) => (
            <TableRow key={rowIndex}>
              {Array.from({ length: columns }).map((_, colIndex) => (
                <TableCell key={colIndex}>
                  <Skeleton
                    variant="text"
                    width={colIndex === 0 ? '60%' : '80%'}
                  />
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
